import { RequireAccess } from '@/components'
import { type ReactNode, useMemo } from 'react'
import { createFontPickerStore, FontPickerStoreContext } from './store'
import { FontPickerPicker } from './ui'

/**
 * Mount this once in the app frame, wrapping the app's content.
 * Provides the font picker store to all descendants and renders
 * the picker dialog when opened via `useFontPicker().open()`.
 */
export function FontPickerManager({ children }: { children?: ReactNode }) {
	const store = useMemo(() => createFontPickerStore(), [])

	return (
		<FontPickerStoreContext.Provider value={store}>
			<RequireAccess role="jobillan">
				<FontPickerPicker />
			</RequireAccess>
			{children}
		</FontPickerStoreContext.Provider>
	)
}
